import React from 'react';
import type { TFunction } from 'wix-rich-content-common';
import { GenericError } from 'wix-rich-content-ui-components';

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode; t: TFunction },
  { hasError: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    console.error(error);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <GenericError text={this.props.t('Plugin_Rendering_Error')} dataHook={'rendering-error'} />
      );
    }

    return this.props.children;
  }
}
